import {EVENT_BUS_MENU_RERENDER} from "../sections/const"
import Section from "../../../core/model2/project/section"
import MoveManager from "../../../core/gd/manager/move-manager";

export default async function menu_sectionMoveDown(section: Section) {
    const nextSectionProject = section.nextSectionProject
    if (nextSectionProject) {
        const oldSortPosition = section.project.sortPosition
        const newSortPosition = nextSectionProject.sortPosition

        nextSectionProject.sortPosition = oldSortPosition
        section.project.sortPosition = newSortPosition

        MoveManager.setProjectSortPosition(section.project.id, newSortPosition)

        gd.bus.triggerEvent(EVENT_BUS_MENU_RERENDER)
    }
}